export default {
  cancelUnpaidCheckout: "Cancel",
  changeSelection: "Change my selection",
  packIncludesBoost:
    "Includes the {{count}}-day boost, which runs at the top of its category.",
  cartHeading: "Review your services",
  cartLead: "All listed services are included in one payment.",
  existingPayment:
    "An unfinished payment is available. Review its original items before paying again.",
  resumePackagePayment: "Review unfinished payment",
  emptyCart: "No services selected.",
  removeItem: "Remove",
  currentCart: "Current selection",
  reviewCartChanged:
    "The selection changed. Review the updated items and accept the terms again.",
  quoteExpiredCart:
    "This promotion quote expired. Choose it again from the ad.",
  chooseAgain: "Choose again",
  contextCreateAd: "New listing price",
  contextMyAds: "My ads price",
  paymentOriginal: "Original payment",
  viewCart: "Review selected services",

  continueToCart: "Continue to shared checkout",
  bankRateNote: "You pay in euros. Your bank converts at its own rate.",
  reverseVat: "Reverse charge VAT · one-time payment",
  checkout: "Continue to payment",
  resumePayment: "Resume payment",
  storeReceipt: "See store receipt",
  title: "Give your listing a little more spotlight",
  lead: "Choose paid visibility, a distinctive look, or both. Your listing stays yours.",
  boost: "Boost",
  boostDetail: "Rotating Sponsored spots in relevant searches.",
  highlight: "Highlight",
  highlightDetail:
    "A subtle green frame helps your listing stand out. No ranking change.",
  bundle: "Stand out",
  bundleDetail: "Boost and Highlight, together for seven days.",
  days: "{{count}} days",
  preview: "Your listing preview",
  previewNote: "An illustration of the appearance, not a guaranteed position.",
  choose: "Choose an option",
  continue: "Review promotion",
  notNow: "Not now",
  total: "Total",
  vat: "Including VAT · one-time payment",
  saving: "Save {{amount}} compared with buying separately",
  terms:
    "Delivery starts when your listing is approved and available. It pauses while unavailable and ends if sold or withdrawn.",
  consent:
    "I accept the promotion terms and request delivery to start as soon as my listing is eligible.",
  pay: "Pay {{amount}}",
  paying: "Processing…",
  error: "Something went wrong. Please try again.",
  retry: "Try again",
  unavailable: "Promotions are not available for this listing right now.",
  history: "Your promotions",
  myAdsCta: "Promotions",
  processingPayment: "Processing payment",
  activeUntil: "Until {{date}}",
  endedOn: "Ended {{date}}",
  report: "Campaign performance",
  impressions: "Visible impressions",
  clicks: "Clicks",
  ctr: "Click-through rate",
  noData: "No reporting data yet",
  metricsNote:
    "Recorded campaign events, not unique people or incremental sales. An impression requires at least half the card on screen for one second.",
  updated: "Updated {{date}}",
  start: "Started",
  end: "Ends",
  withdraw: "Withdraw promotion",
  withdrawConfirm: "Stop this promotion?",
  withdrawNote:
    "Delivery stops immediately. Any refund is assessed separately; this does not promise a refund.",
  cancel: "Keep promotion",
  confirm: "Stop delivery and request review",
  back: "Back to My ads",
  sponsored: "Sponsored",
  advertiser: "Paid for by {{name}}",
  reason: "Why this listing?",
  processing:
    "We are checking your payment with the server. Closing this page will not cancel a completed payment.",
  refresh: "Refresh status",
  paymentConfirmed: "Payment confirmed",
  awaiting_payment: "Awaiting payment",
  awaiting_listing: "Waiting for your listing",
  active: "Active",
  paused: "Paused",
  completed: "Completed",
  cancelled: "Cancelled",
  refund_required: "Needs review",
  refunded: "Refunded",
  refund_requested: "Refund requested",
  pending: "Pending",
  paid: "Paid",
  failed: "Failed",
  payment: "Payment",
  noCampaign: "No campaigns yet. Your first promotion will appear here.",
  viewCampaign: "View campaign",
  checking: "Checking availability…",
  expired: "This quote has expired. Refresh it before paying.",
  noGuarantee: "No guarantee of ranking, impressions or a sale.",
  previewFixture:
    "Local preview · fictional listing and sample data · no purchase",
  daily: "Daily activity (UTC)",
  date: "Date",
  selected: "Selected",
  viewTerms: "Read the terms",
  termsTitle: "Promotion terms",
  termsBody:
    "This is a one-time paid advertising service. Sponsored places rotate among relevant listings; Highlight changes appearance only. The duration runs only while eligible. Withdrawal stops delivery and starts a human refund assessment. Your legal rights are unaffected.",
  entryTitle: "Help the right buyers find your piece",
  entryBody:
    "Choose how your listing gets noticed, in search and on the homepage.",
  entryCta: "Explore promotion options",
  editorTitle: "Promote your listing",
  stepChoose: "Choose",
  stepReview: "Review",
  stepPayment: "Payment",
  boostBenefit: "Get discovered",
  highlightBenefit: "Catch the eye",
  bundleBenefit: "Do both",
  boostBody: "Sponsored spots in relevant searches.",
  highlightBody:
    "Give your listing a distinctive green frame in search and category results.",
  bundleBody:
    "Sponsored visibility and a green frame, together for seven days.",
  chooseDuration: "Choose your duration",
  previewOriginal: "Your listing",
  previewPromoted: "With your promotion",
  selectionHint: "Choose an option to continue",
  reviewTitle: "Your promotion, at a glance",
  startsWhenReady: "Starts when your listing is approved and available",
  pausesWhenNeeded: "Pauses while your listing is temporarily unavailable",
  trackResults: "Follow impressions and clicks in My ads",
  close: "Close",
  changeOption: "Change option",
  fromPrice: "From {{amount}}",
  placementPreview: "Sponsored results",
  appearancePreview: "Search results",
  previewEmpty: "See how your listing could appear",
  oneTime: "One-time payment",
  reportListing: "Your listing",
  viewListing: "View listing",
  reportActivity: "Promotion activity",
  reportAllTime: "Over the whole promotion",
  reportShown: "Times shown",
  reportShownHelp: "Your promoted listing was visible on screen.",
  reportClicksHelp: "Clicks on your promoted listing.",
  reportRateHelp: "Clicks divided by recorded impressions.",
  reportChecked: "Report checked {{date}}",
  reportDaily: "Activity by day",
  reportPeriod: "Reporting period",
  reportFullPeriod: "Full period",
  reportLastDays: "Last {{count}} days of activity",
  reportRecordedDays:
    "Only dates with recorded activity are shown. Days are grouped in UTC.",
  reportDataTable: "View daily figures",
  reportNoActivity: "No activity recorded",
  reportNoActivityBody:
    "Recorded impressions and clicks will appear here. The totals above show what has been measured so far.",
  reportBeforeStart: "Your report will begin when delivery starts.",
  reportPurchase: "Your promotion",
  reportIncluded: "Included in this promotion",
  reportAmount: "Purchase amount",
  reportPurchased: "Payment received",
  reportReference: "Campaign reference",
  reportScheduledEnd: "Scheduled end",
  reportFinishedOn: "Finished",
  reportSupport: "Contact support",
  reportRefreshWarning:
    "We could not refresh this report. Your last available information is still shown.",
  reportPollingStopped:
    "Still waiting for a payment update. Automatic checks have paused; refresh the status to check again.",
  reportResumeBody:
    "Continue with your existing payment. If you have already paid, refresh the status before trying again.",
  reportPendingBody:
    "Payment has not been confirmed yet. Check the original payment or app store; you do not need to buy another promotion.",
  reportActiveTitle: "Your promotion is running",
  reportActiveBody:
    "Your selected benefits are active while your listing is available to buyers.",
  reportWaitingTitle: "Ready when your listing is",
  reportWaitingBody:
    "Payment is confirmed. Your promotion starts once your listing is approved and available. Your paid time has not started yet.",
  reportPausedTitle: "Your promotion is paused",
  reportPausedBody:
    "Your listing is temporarily unavailable. Delivery will resume when it is available again, with the paused time added back.",
  reportHolidayBody:
    "Delivery is paused while your shop is on holiday. Your paid time is preserved until your listing is available again.",
  reportReservedBody:
    "Your listing is reserved. Delivery is paused while the reservation is in place; your paid time is preserved.",
  reportVerificationBody:
    "We are checking your app store purchase. Delivery is paused and your paid time is preserved. You do not need to purchase again.",
  reportPlatformPauseBody:
    "We have temporarily paused promotion delivery. Your paid time is preserved; no action is needed from you.",
  reportApprovalBody:
    "Your listing is being reviewed. Delivery will start or resume when it is approved and available; waiting time does not use your promotion.",
  reportFinishedTitle: "Your promotion has finished",
  reportFinishedBody:
    "Your purchased delivery period is complete. The report below shows the activity recorded during your promotion.",
  reportSoldBody:
    "Your listing was sold, so promotion delivery ended. The activity below is recorded delivery, not evidence that the promotion caused the sale.",
  reportWithdrawnBody:
    "Your listing is no longer available, so promotion delivery has stopped.",
  reportStoppedTitle: "Promotion delivery has stopped",
  reportStoppedBody:
    "This promotion is no longer delivering. Your recorded activity and purchase details remain available below.",
  reportReviewTitle: "Your promotion needs a review",
  reportReviewBody:
    "Delivery has stopped while we review this purchase. Contact support if you need help; a refund has not been confirmed.",
  reportWithdrawalBody:
    "Your request has been received and delivery has stopped. Any refund is assessed separately.",
  reportRefundedTitle: "Payment refunded",
  reportRefundedBody:
    "A refund has been confirmed and this promotion is no longer delivering.",
  reportNotFound: "We could not find this promotion in your account.",
  reportWithdrawalFailed:
    "We could not confirm your request. This window is still open so you can try again. Check the campaign status if you are unsure.",
  reportRequestReview: "Request a review",
  reportReviewConfirm: "Request a review of this promotion?",
  reportReviewNote:
    "Delivery has already ended. We will assess your request separately; this does not promise a refund.",
  reportConfirmReview: "Send review request",
  reportEndedNoActivity:
    "No activity was recorded before this promotion stopped.",
  customPromotion: "Your promotion",
  border: "Frame",
  label: "Label",
  homepage: "Homepage spot",
  fullBundle: "Stand out pack",
  selectBundle: "Choose Stand out",
  bundleIncludes: "Boost, Frame and Label for 7 days",
  bundleSaving: "Save {{amount}} compared with buying separately",
  bundleRecommendation:
    "Get 7 days of Boost, Frame and Label for {{amount}} — less than this selection.",
  borderBody: "A green frame on your card.",
  labelBody: "Your seller-selected label.",
  homepageBody: "Rotating Sponsored homepage cards.",
  homepageTerms:
    "A rotating place, not an exclusive position. No guaranteed impressions or sale.",
  homepageHeading: "Discover more",
  homepageContext: "On the homepage",
  homepagePreviewNote:
    "Your card joins a rotating Sponsored selection. This preview does not promise a position.",
  labelChoose: "Choose a label",
  labelMustGo: "Must go",
  labelMovingSale: "Moving sale",
  labelInvoice: "With original invoice",
  labelCollect: "Ready to collect",
  labelAttestation: "I confirm that this label is true for my listing.",
  labelPaidNote:
    "Chosen by the seller and paid for. This is not a Whoppah verification.",
  labelRequired: "Choose a label and confirm it is true before continuing.",
  none: "None",
  addBenefit: "Add {{benefit}}",
  removeBenefit: "Remove {{benefit}}",
  selectionUnavailable:
    "This selection is currently unavailable. Change your choices or check availability again.",
  effectUnavailable: "Already running or unavailable for this listing",
  homepageSoldOut:
    "Homepage spots are currently full. Choose other benefits or check again later.",
  checkAvailability: "Check availability",
  mixedDurationNote:
    "Each benefit has its own duration. The homepage spot ends after 3 days; longer benefits continue.",
  selectedBenefits: "Your selected benefits",
  benefitStatus: "Benefit status",
  placementsTitle: "Where your promotion appeared",
  placementSearch: "Search results",
  placementCategory: "Category results",
  placementCard: "Card frame and label",
  placementHomepage: "Homepage",
  placementLegacyHighlight: "Highlighted cards",
  placementOther: "Other placement",
  sharedExposureNote:
    "One card may include benefits from several purchases. Campaign totals are recorded exposures, not unique reach.",
  homepageCapacityWait:
    "Your payment is confirmed. Delivery will begin when a homepage spot and your listing are available. Your purchased time has not started.",
  labelSuppressed:
    "This label has been stopped for review. Contact support for help with your purchase.",
  newBenefits: "Add other promotion benefits",
  previewSearch: "Search and category card",
  previewHome: "Homepage card",
  benefitEnd: "Scheduled benefit end",
  benefitStarts: "Benefit started",
  historicalBundle: "Boost and Highlight",
  bundleV2Body:
    "Boost, a green frame and your selected label, together for 7 days.",
  customPromotionBody: "Your chosen promotion benefits.",
  customPromotionBenefit: "Choose your benefits",
  placementPartial:
    "Placement details are unavailable for some recorded activity. Your campaign totals still include that activity.",
  reportSomeActiveBody:
    "At least one benefit is running. Check each benefit below for its own status and dates.",
  homepageWaitReview:
    "No homepage spot became available within the waiting period. This purchase needs a refund review; no refund is confirmed yet.",
  chooseBenefits: "Build your promotion",
  selectionBenefitsHint: "Choose one or more benefits",
  termsBodyV2:
    "This is a one-time paid advertising service. Homepage places rotate. Frame and Label change card appearance; labels are chosen and confirmed by the seller, not verified by Whoppah. Each benefit runs for its own purchased duration while eligible. A purchase including a homepage spot starts when a spot and the listing are ready. Withdrawal stops delivery and starts a human refund assessment. Your legal rights are unaffected.",
  homepageStartFact:
    "Starts when your listing and a homepage spot are available",
  salesEyebrow: "MAKE IT STAND OUT",
  salesTitle: "Good design deserves to be seen.",
  salesBody: "Choose a package or build your own.",
  offerBoostBody: "Get in front of buyers searching for pieces like yours.",
  offerBundleBody: "Extra visibility. A distinctive look. All in one package.",
  offerHomeTitle: "Stand out + homepage",
  offerHomeBody: "Stand out in search and catch the eye of homepage browsers.",
  offerBoostCta: "Choose Boost",
  offerHomeCta: "Choose package",
  offerAllTogether: "Visibility + style",
  offerWiderReach: "Search + homepage",
  offerSearchReach: "Search visibility",
  offerRecommended: "Our pick",
  offerMixedDuration: "Stand out 7 days · Homepage 3 days",
  offerSearchBenefit: "Sponsored spots in relevant searches",
  offerStyleBenefit: "Green frame + seller label",
  offerResultsBenefit: "Follow impressions and clicks in My ads",
  offerBundleBenefit: "Boost + Frame + Label",
  offerHomeBenefit: "Rotating homepage spot",
  offerSelected: "Selected",
  offerCustomize: "Choose individual options",
  offerMakeYours: "Your preview",
  offerPreviewBody: "Check your selection before paying.",
  completionOptional:
    "Promotion is optional. You can also choose later in My ads.",
  individualOptionsBody: "Pick one or combine.",
  individualLink: "See individual options",
  standOutTitle: "Make it stand out",
  standOutLead: "Pick one or more. Starts when your ad is live and available.",
  packDetail: "7-day boost, frame and a label together.",
  bestValue: "Best value",
  percentOff: "{{percent}}% off",
  orSeparately: "or choose separately",
  boostPickerDetail:
    "Your ad goes back to the top of its category. Starts once your ad is live.",
  boostRunning:
    "This ad already has a boost running. You can add a new boost once it has ended.",
  framePickerDetail:
    "A green frame around your ad in search results, for 7 days.",
  labelMustGoTitle: "'Must go' label",
  previousPaymentProcessing:
    "Your previous payment is still being processed. Try again in a minute.",
  labelPickerDetail: "A short label on your ad for 7 days.",
  homepagePickerDetail: "A rotating Sponsored homepage card for 3 days.",
  searchPreviewTitle: "How your ad looks in search results",
  searchPreviewLead:
    "Your listing, with grey placeholders for the ads around it.",
  promotedTab: "Promoted",
  boostSummary: "{{count}}-day boost",
  labelSummary: "Label “{{text}}”",
  nothingSelected: "Nothing selected",
  continueWithPrice: "Continue to payment · {{price}}",
  goToMyAds: "Go to My ads",
  pricingContextChanged:
    "The create-ad discount is no longer available. Prices have been refreshed.",
} as const;
